<ng-container *ngIf="!loaderService.isLoading">
  <div class="loader-overlay" data-automation="progress-loader-overlay"></div>
  <div
    class="flex flex-col justify-start items-center loader-container"
    data-automation="progress-loader"
  >
    <mat-progress-bar
      [mode]="stage === 'initializing' ? 'indeterminate' : 'determinate'"
      [value]="progress.progress"
    ></mat-progress-bar>
    <h2 *ngIf="stage === 'initializing'">
      {{ 'loader.message.run.forecast.initializing' | translate }}
    </h2>
    <h2 *ngIf="stage === 'finalizing'">
      {{ 'loader.message.run.forecast.finalizing' | translate }}
    </h2>
    <h2 *ngIf="stage === 'iterating'" id="loader-title">
      {{ translateString | translate }}
    </h2>
    <h2 *ngIf="stage === 'iterating'">
      {{ progress.progress.toFixed(0) }}%
      {{ 'loader.message.run.forecast.status' | translate }}
    </h2>
    <h2 *ngIf="stage === 'stalled'">
      {{ 'loader.message.run.forecast.stalled' | translate }}
    </h2>
    <button
      *ngIf="stage === 'stalled'"
      class="flex items-center icon-btn x-btn x-btn-secondary"
      mat-ripple
      aria-label="run-with-forecasted"
      data-automation="run-with-forecasted"
      (click)="restartSimulation()"
    >
      <mat-icon svgIcon="spin" class="fill-primary"></mat-icon>

      <span class="ml-1">
        {{ 'scenario.button.rerun.forecasted' | translate }}
      </span>
    </button>
    <h3 *ngIf="stage === 'stalled'" class="multiline">
      {{ 'loader.message.run.forecast.stalled.subtext' | translate }}
    </h3>
    <h3
      *ngIf="estimation === 0 && stage !== 'finalizing' && stage !== 'stalled'"
      id="loader-sub-title"
    >
      {{ translateStringSubtext | translate }}
    </h3>
    <h3 *ngIf="estimation !== 0 && stage === 'iterating'">
      {{ 'loader.message.run.forecast.estimation' | translate }}:
      {{ Math.floor(estimation / 3600) }} hours
      {{ Math.floor((estimation % 3600) / 60) }} minutes
      {{ Math.round(estimation % 60) }} seconds
    </h3>
  </div>
</ng-container>
